import { render, staticRenderFns } from "./PanelMotorsPercentage.vue?vue&type=template&id=58e551c9&lang=pug&"
import script from "./PanelMotorsPercentage.vue?vue&type=script&lang=js&"
export * from "./PanelMotorsPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports